if (!customElements.get('card-carousel-tabs')) {
    class CardCarouselTabs extends HTMLElement {
        constructor() {
            super();
            this.currentTab = null;
        }

        connectedCallback() {
            this.initializeElements();
            this.attachEventListeners();
            this.activateFirstTab();
        }

        initializeElements() {
            this.tabButtons = this.querySelectorAll('.tab-button');
            this.carousels = this.querySelectorAll('[data-tab-carousel]');
            this.underline = this.querySelector('[data-underline]');
            this.tabsContainer = this.querySelector('[data-tabs-container]');
        }

        attachEventListeners() {
            this.tabButtons.forEach((button) => {
                button.addEventListener('click', () => {
                    const tabId = button.getAttribute('data-tab');
                    this.switchTab(tabId, button);
                });
            });
        }

        activateFirstTab() {
            if (this.tabButtons.length > 0) {
                const firstButton = this.tabButtons[0];
                const firstTabId = firstButton.getAttribute('data-tab');
                this.switchTab(firstTabId, firstButton);
            }
        }

        switchTab(tabId, clickedButton) {
            this.currentTab = tabId;

            this.tabButtons.forEach((btn) => {
                if (btn === clickedButton) {
                    btn.classList.add('active');
                    btn.style.opacity = '1';
                } else {
                    btn.classList.remove('active');
                    btn.style.opacity = '0.5';
                }
            });

            // Update carousel visibility
            this.carousels.forEach((carousel) => {
                const carouselTab = carousel.getAttribute('data-tab-carousel');
                if (carouselTab === tabId) {
                    carousel.classList.remove('hidden');
                    carousel.classList.add('block');
                } else {
                    carousel.classList.add('hidden');
                    carousel.classList.remove('block');
                }
            });

            // Animate underline
            this.animateUnderline(clickedButton);
        }

        animateUnderline(button) {
            const buttonRect = button.getBoundingClientRect();
            const containerRect = this.tabsContainer.getBoundingClientRect();

            const left = buttonRect.left - containerRect.left;
            const width = buttonRect.width;

            this.underline.style.left = `${left}px`;
            this.underline.style.width = `${width}px`;
        }
    }

    customElements.define('card-carousel-tabs', CardCarouselTabs);
}